import React from 'react';
import { X, CheckCircle } from 'lucide-react';

const AlertModal = ({
    alert,
    setAlert
}) => {
    if (!alert.show) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gray-900 rounded-xl border border-gray-800 w-full max-w-md">
                <div className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center ${alert.type === 'success' ? 'bg-green-500/20' : 'bg-red-500/20'
                            }`}>
                            {alert.type === 'success' ? (
                                <CheckCircle className="w-6 h-6 text-green-400" />
                            ) : (
                                <X className="w-6 h-6 text-red-400" />
                            )}
                        </div>
                        <h2 className="text-xl font-bold">{alert.type === 'success' ? 'Success' : 'Error'}</h2>
                    </div>
                    <p className="text-gray-400 mb-6">{alert.message}</p>
                    <div className="flex justify-end">
                        <button
                            onClick={() => setAlert({ show: false, message: '', type: 'success' })}
                            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;
